<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />

    <device-bar
      v-if="getData && getData.cls == 'device'"
      :open="getDeviceBarOpen"
      modalMode
      :modalActive="getData"
      noclose--
      noedit
      @load-devices=""
      @close="() => {this.$emit('close', getData)}"
    />

    <popup-card
      v-if="getData && getData.cls == 'connection'"
      :data="getData"
      @close="() => {this.$emit('close', getData)}"
    />
  </v-container>
</template>

<script>

import loadingCircle from '@/nms/components/partials/loader.vue'
import DeviceBar from '@/nms/pages/device/device-bar.vue'
import popupCard from '@/nms/pages/topology/popup-card.vue'

export default {

  name: 'JOURNAL_MODAL',

  components: {
    loadingCircle,
    DeviceBar,
    popupCard
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    },
  },

  data: () => ({
    loader: false,
    bar: {
      device: {
        open: false
      },
    },

  }),

  computed: {
    getDeviceBarOpen: function () {
      // избавляемся от watcher
      const dev = this.$store.state.devices.activeDevice
      this.bar.device.open = (dev && dev.$id) ? true : false
      return this.bar.device.open
    },
    
    getData: function () {
      return this.data
    },
  },

  watch: {},

  created () {
    this.setup()
  },

  mounted () {},

  updated () {},

  beforeDestroy () {},

  methods: {
    setup: async function () {
      console.log('JOURNAL_MODAL', 'data', this.data)
      this.reset()
    },

    reset: function () {}
  }
}
</script>

<style scoped>
</style>
